import { render, staticRenderFns } from "./bill-form-received.vue?vue&type=template&id=7538aed0&scoped=true"
import script from "./bill-form-received.vue?vue&type=script&lang=js"
export * from "./bill-form-received.vue?vue&type=script&lang=js"
import style0 from "./bill-form-received.vue?vue&type=style&index=0&id=7538aed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538aed0",
  null
  
)

export default component.exports